// src/AppNoClerk.js
import React from "react";
import FrontPage from "./FrontPage";

export default function AppNoClerk() {
  // Minimal shell to show the FrontPage without Clerk.
  // Clicking Start will show a gentle message since auth is unavailable.
  const showAuthNotice = () => {
    alert("Sign in is temporarily unavailable: missing Clerk publishable key.\n\nPlease try again later or contact support.");
  };

  const noop = () => {};

  return (
    <div>
      <FrontPage
        onOpen={noop}
        onShowAuth={showAuthNotice}
        onShowSignup={showAuthNotice}
        isSignedIn={false}
        user={null}
      />
    </div>
  );
}




